module.exports = __webpack_public_path__ + "static/media/PaperFootballLogo.fbe6232f.png";